interface HeroVideoData {
  _id: string;
  videoFile: {
    asset: {
      url: string;
    };
  };
  posterImage?: {
    asset: {
      url: string;
    };
  };
}

interface VideoHeroProps {
  data: HeroVideoData;
}

export default function VideoHero({ data }: VideoHeroProps) {
  return (
    <section className="max-w-laptop relative mx-auto flex min-h-[675px] items-center justify-center overflow-hidden">
      {/* Loading State */}
      {!data && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-black">
          <div className="flex flex-col items-center">
            <div className="mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-white"></div>
            <p className="text-white">Loading video...</p>
          </div>
        </div>
      )}

      {/* Video Background */}
      <div className="absolute inset-0 h-full w-full">
        <video
          className="h-full w-full object-cover"
          poster={data?.posterImage?.asset.url}
          autoPlay
          muted
          loop
          playsInline>
          <source src={data?.videoFile?.asset.url} type="video/mp4" />
        </video>
      </div>
    </section>
  );
}
